import axios from 'axios';

const BASE = '';
const API = axios.create({ baseURL: `${BASE}/api` });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export const authService = {
  login: (data) => API.post('/auth/login', data),
  me: () => API.get('/auth/me'),
};

export const orderService = {
  getAll: (search) => API.get('/orders', { params: search ? { search } : {} }),
  getOne: (id) => API.get(`/orders/${id}`),
  create: (data) => API.post('/orders', data),
  update: (id, data) => API.put(`/orders/${id}`, data),
  updateStatus: (id, status) => API.patch(`/orders/${id}/status`, { status }),
  anular: (id, motivo) => API.patch(`/orders/${id}/anular`, { motivo }),
};

export const clientService = {
  getAll: (search) => API.get('/clients', { params: search ? { search } : {} }),
  getOne: (id) => API.get(`/clients/${id}`),
};

export const inventoryService = {
  getProducts: () => API.get('/inventory/products'),
  getCategories: () => API.get('/inventory/categories'),
  getAlerts: () => API.get('/inventory/alerts'),
  createProduct: (data) => API.post('/inventory/products', data),
  deleteProduct: (id) => API.delete(`/inventory/products/${id}`),
  createVariant: (data) => API.post('/inventory/variants', data),
  updateVariant: (id, data) => API.put(`/inventory/variants/${id}`, data),
  addMovement: (data) => API.post('/inventory/movements', data),
};

export const configService = {
  getLogoUrl: () => `${BASE}/api/config/logo`,
  uploadLogo: (file) => {
    const formData = new FormData();
    formData.append('logo', file);
    return API.post('/config/logo', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};

export const userService = {
  getAll: () => API.get('/users'),
  create: (data) => API.post('/users', data),
  update: (id, data) => API.put(`/users/${id}`, data),
  changePassword: (id, data) => API.put(`/users/${id}/password`, data),
};

export default API;
